var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.className,attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }